import React from 'react';

const DataTable = ({ 
  children, 
  emptyState,
  className = '',
  ...props 
}) => {
  return (
    <div className={`bg-white rounded-lg shadow overflow-hidden ${className}`} {...props}>
      {emptyState ? (
        emptyState
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            {children}
          </table>
        </div>
      )}
    </div>
  );
};

export default DataTable;
